import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaTreeNode } from "./VaTreeNode-96505897.mjs";
const VaTreeNode = withConfigTransport(_VaTreeNode);
export {
  VaTreeNode as V
};
//# sourceMappingURL=index-40b30bf6.mjs.map
